var _path, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-plus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMembers);
export default __webpack_public_path__ + "static/media/add-members.09121f9f4e478377be6e083aa79210e5.svg";
export { ForwardRef as ReactComponent };